

export default function getProducts(room, austattung_produkt){

    const productList = [];
    const schaltbare = [];
    const normal = [];

    if(
        room.selectedEquipment["steckdosen_aufputz"] !== undefined
        && room.selectedEquipment["steckdosen_aufputz"] > 0
        && austattung_produkt["steckdose-aufputz"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["steckdose-aufputz"],
            count: room.selectedEquipment["steckdosen_aufputz"]
        })
        for (let i = 0; i<room.selectedEquipment["steckdosen_aufputz"];i++) {
            normal.push(austattung_produkt["steckdose-aufputz"]);
        }
    }
    return { productList, schaltbare, normal };
}
